import React from 'react';

function Link({ url, children, ariaLabel, ariaExpanded, external = false, }) {
    return (React.createElement("a", Object.assign({ href: url }, (external && { target: "_blank" }), (ariaLabel && { "aria-label": ariaLabel }), (ariaExpanded && { "aria-expanded": ariaExpanded })), children));
}

export { Link as L };
